import apiClient from '../../../services/apiClient'

export function OrderManager({ apiToken, onExportCsv, rows = [], onRefresh }) {
  const remind = async (row) => {
    if (!apiToken) return
    try {
      await apiClient.sendOrderReminder(apiToken, row.rawId)
      await onRefresh?.('Checkout reminder sent')
    } catch (error) {
      await onRefresh?.(error.message || 'Reminder failed')
    }
  }

  const ship = async (row) => {
    if (!apiToken) return
    try {
      await apiClient.shipOrder(apiToken, row.rawId, `OBC-${Date.now().toString().slice(-8)}`)
      await onRefresh?.('Order marked shipped')
    } catch (error) {
      await onRefresh?.(error.message || 'Ship action failed')
    }
  }

  const relist = async (row) => {
    if (!apiToken) return
    try {
      await apiClient.relistOrder(apiToken, row.rawId)
      await onRefresh?.('Order queued for relist')
    } catch (error) {
      await onRefresh?.(error.message || 'Relist action failed')
    }
  }

  const applyPenalties = async () => {
    if (!apiToken) return
    try {
      const response = await apiClient.applyOrderPenalties(apiToken)
      await onRefresh?.(`${response.applied} unpaid penalties applied`)
    } catch (error) {
      await onRefresh?.(error.message || 'Penalty job failed')
    }
  }

  const sendEligibleReminders = async () => {
    if (!apiToken) return
    try {
      const response = await apiClient.sendEligibleOrderReminders(apiToken)
      await onRefresh?.(`${response.sent} eligible checkout reminders sent`)
    } catch (error) {
      await onRefresh?.(error.message || 'Eligible reminder job failed')
    }
  }

  return (
    <section className="tactical-card obc-admin__builder">
      <div className="obc-admin__panel-head">
        <div>
          <h2>Order Manager</h2>
          <span>Checkout reminders, shipping, unpaid penalties, and relist queue</span>
        </div>
        <div className="obc-consignment-admin-actions">
          <button type="button" onClick={() => onExportCsv?.(apiToken, 'orders', 'obc-orders.csv', onRefresh)}>Export CSV</button>
          <button type="button" onClick={sendEligibleReminders}>Send Eligible Reminders</button>
          <button type="button" onClick={applyPenalties}>Apply Penalties</button>
        </div>
      </div>
      <div className="obc-order-admin-grid">
        {rows.map((row) => {
          const canShip = row.status === 'paid' || row.shipping === 'ready to ship'
          const canRelist = row.action === 'Queue relist'
          const canRemind = ['payment pending', 'weekly hold', 'penalty applied'].includes(row.status)

          return (
          <article key={row.rawId || row.id}>
            <div>
              <strong>{row.id}</strong>
              <span>{row.user} / {row.total}</span>
              <small><b className={`obc-order-stage is-${row.workflowTone || 'neutral'}`}>{row.workflowStage || row.status}</b> {row.shipping} / reminders {row.reminders}</small>
              <small>Due: {row.due} / Penalty: {row.penaltyAt} / Relist: {row.relistAt}</small>
              <small>Tracking: {row.tracking}</small>
            </div>
            <div className="obc-consignment-admin-actions">
              <button type="button" onClick={() => remind(row)} disabled={!canRemind}>Reminder</button>
              <button type="button" onClick={() => ship(row)} disabled={!canShip}>Ship</button>
              <button type="button" onClick={() => relist(row)} disabled={!canRelist}>Relist</button>
            </div>
          </article>
          )
        })}
      </div>
    </section>
  )
}

export function AdminOrdersModule({ apiToken, onExportCsv, onRefresh, orderRows }) {
  return <OrderManager apiToken={apiToken} onExportCsv={onExportCsv} rows={orderRows} onRefresh={onRefresh} />
}
